import React from 'react';
import {Controller} from 'react-hook-form';
import styles from './styles.module.scss';
import Text from 'components/typografy/text';
import {FaCheck} from 'react-icons/fa6';
import classNames from 'classnames';

const Checkbox: React.FC<{
  control: any;
  name: string;
  error?: string | '';
  label: string;
  rules: Record<string, any>;
}> = ({control, name, error, label, rules}) => {
  return (
    <Controller
      rules={rules}
      render={({field}) => {
        return (
          <div className={styles.wrapper}>
            <label className={styles.input}>
              <input type="checkbox" {...field} />
              <span className={classNames(styles.checkbox, {[styles.active]: field.value})}>
                <FaCheck />
              </span>
              <Text variant={'medium'}>{label}</Text>
            </label>
            {error && <div className={styles.error}>{error}</div>}
          </div>
        );
      }}
      name={name}
      control={control}
    />
  );
};
export default Checkbox;
